module.exports = __webpack_public_path__ + "static/settings.json";


//////////////////
// WEBPACK FOOTER
// ./src/settings.json
// module id = k0KG
// module chunks = 98